import { useNavigate } from 'react-router-dom';
import Logo from '../assets/images/FESPRIS KITCHEN MAIN LOGO.png'
import { FaRegUserCircle } from 'react-icons/fa';
import { CiLock } from 'react-icons/ci';
import { useState } from 'react'
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { persistAuth } from '../redux/slices/authSlice';
import { SignIn } from '../services/authService';
import { toast } from 'react-toastify';
import ButtonLoader from '../components/ButtonLoader';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      UserName: '',
      PassWord: '',
    },
    validationSchema: Yup.object({
      UserName: Yup.string()
      .required('UserName is required'),
      PassWord: Yup.string()
      .required('Password required.')
      .min(6, 'Password is too short -  should be 6 chararacters minimum with one Uppercase at least.')
      .matches(/[A-Z]+/, "password must contain at least 1 uppercase letter")
      .matches(/\d+/, "password must contain at least 1 number"),
    }),

    onSubmit: async (values) => {
      if (!values.UserName || !values.PassWord) {
        toast.error("Both username and password are required.");
        return;
      } 
      setLoading(true)
      try {
        const res = await SignIn({
          UserName: values.UserName,
          PassWord: values.PassWord,
        });
        console.log(res)
        
        const  data = res?.data?.isLoggedIn;
        if(data){
          dispatch(persistAuth(res));
          navigate('/overview');
          setLoading(false)
        }else if(res.status === "false" || res.statusCode === 205 || !data) {
          toast.error(res.message)
          setLoading(false)
        } else if(res?.statusCode === 404){
          toast.error(res.message)
          setLoading(false)
        } else if(res?.statusCode === 90){
          toast.error(res.message)
          setLoading(false)
        } else{
          console.error(res.message)
          setLoading(false)
        }
        
      } catch (error) {
        console.error(error.message)
      }

    },
  });
  console.log(formik.values)

  return (
    <section className="h-screen">
      <div className="bg-primaryRed h-[95vh]">
        <div className="grid place-items-center py-2">
          <img src={Logo} alt="logo" className="w-[150px]" />
          <div className="bg-white rounded-2xl p-7 max-w-sm mt-4 px-8">
            <h3 className="text-2xl text-center">
              Welcome to Fespris Kitchen Admin Dashboard
            </h3>
            <p className="text-center text-xs mt-3 text-[#0A0A0A]/90">
              Securely access your dashboard to manage customer orders, delivery, and
              customer satisfaction. Let’s keep things running smoothly.
            </p>
            <form onSubmit={formik.handleSubmit}
              className="px-6 sm:px-6 pt-4 pb-0"
            >
              <label htmlFor="UserName">Username</label>
              <div className="my-2 relative">
                <input 
                  id="UserName"
                  name="UserName"
                  value={formik.values.UserName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="border-2 border-[#00000] border-opacity-30 rounded-md px-10 w-full py-1.5 outline-none ring-0"  />
                  <FaRegUserCircle className='absolute left-3 top-2 text-xl' />
                  {formik.touched.UserName && formik.errors.UserName ? (
                    <div className='text-sm mt-1 text-red-500'>{formik.errors.UserName}</div>
                  ) : null }
              </div>
              <label htmlFor="password">Password</label>
              <div className="my-2 relative">
                <input
                  id="PassWord"
                  name="PassWord"
                  value={formik.values.PassWord}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className="border-2 border-[#00000] border-opacity-30 rounded-md px-10 w-full py-1.5 outline-none ring-0"
                  type={showPassword ? "text" : "password"}
                  placeholder="Create a password"
                />
                 {formik.touched.PassWord && formik.errors.PassWord ? (
                    <div className='text-sm mt-1 text-red-500'>{formik.errors.PassWord}</div>
                  ) : null }
                <CiLock className='absolute left-3 top-2 text-xl' />
                { showPassword ? (
                  <AiFillEye className='absolute right-3 top-2 text-xl cursor-pointer text-gray-500' onClick={() => setShowPassword(prevState => !prevState)} /> 
                  ) : 
                  (
                  <AiFillEyeInvisible className='absolute right-3 top-2 text-xl cursor-pointer text-gray-500' onClick={() => setShowPassword(prevState => !prevState)} />
                  )
                }
              </div>
                <button type="submit"
                  disabled={loading}
                  className="bg-primaryRed hover:bg-primaryRed/80 text-white py-2 w-full rounded-md text-lg mt-4"
                >
                  {loading ? <ButtonLoader />  : "Login"}
                </button>
            </form>
          </div>
        </div> 
      </div>
      <div className="py-2 px-3 md:px-12 flex items-center justify-between">
        <p className="text-xs md:text-sm leading-[12px]">
          copyrights @2024 Fespris Kitchen
        </p>
        <p className="text-xs md:text-sm leading-[12px] text-primaryRed">
          Developed By <a href="https://www.kaybilltech.com/">KayBill Technologies LTD.</a>
        </p>
      </div>
    </section>
  );
};

export default Login;
